module.exports = __webpack_public_path__ + "static/Derek_White_lo_11-c5e260e7ab00695668ad52b300f31a99.jpg";